import { createRouter, createWebHistory } from "vue-router";
import baseSurvey from "../../data/survey.json";

import SurveyForm from "./SurveyForm";
import NotFoundComponent from "./NotFoundComponent";
import SurveyCompleted from "./SurveyCompleted";
import DejaRepondu from "./DejaRepondu";
import LegalNotice from "./LegalNotice";
import Accessibilite from "./Accessibilite.vue";

// Store sera importé après sa création pour éviter les dépendances circulaires
let storeInstance = null;
export function setStoreInstance(store) {
  storeInstance = store;
}

// Fonction pour obtenir la section par défaut de manière sécurisée
function getDefaultSection() {
  // Utiliser le survey de base pour la redirection initiale
  // Le survey correct sera chargé dans le store selon l'origin
  const sections = Object.keys(baseSurvey.sections);
  return sections.length > 1 ? sections[1] : sections[0];
}

const routes = [
  {
    name: "notFound",
    path: "/:pathMatch(.*)*",
    component: NotFoundComponent,
    meta: {
      title: "404 Not Found"
    }
  },
  {
    name: "Accueil",
    path: "/",
    redirect: {
      name: "Questionnaire",
      params: { section: getDefaultSection() }
    }
  },
  {
    name: "Complet",
    path: "/completer/:param?",
    component: SurveyCompleted,
    meta: {
      title: "Complet",
      keepAlive: true
    }
  },
  {
    name: "DejaRepondu",
    path: "/dejarepondu/:param?",
    component: DejaRepondu,
    meta: {
      title: "Deja Repondu",
      keepAlive: true
    }
  },
  {
    name: "Mentions légales",
    path: "/mentions_legales/:param?",
    component: LegalNotice,
    meta: {
      title: "Mentions légales",
      keepAlive: true
    }
  },
  {
    name: "Accessibilite",
    path: "/accessibilite/:param?",
    component: Accessibilite,
    meta: {
      title: "Accessibilite",
      keepAlive: true
    }
  },
  {
    name: "Questionnaire",
    props: route => ({ query: route.query.q }),
    path: "/:section/:param?",
    component: SurveyForm,
    meta: {
      title: "Questionnaire"
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.afterEach((to, from) => {
  if (to.meta.title !== undefined) {
    document.title = "Formulaire Parrainage";
  }
  
  // Vérifier si l'origin a changé dans l'URL et recharger le survey si nécessaire
  if (storeInstance) {
    storeInstance.dispatch("loadSurveyFromUrl");
  }
});

export default router;
